import {useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {
	isCustomActionEndpointUrlAccessibleEndpoint,
	useReactQueryIsCustomActionEndpointUrlAccessible,
} from '../api';
import type {CustomActionID} from '../types';

export type UseIsCustomActionEndpointUrlAccessibleParams = {
	id?: CustomActionID;
};

export const useIsCustomActionEndpointUrlAccessible = ({
	id,
}: UseIsCustomActionEndpointUrlAccessibleParams) => {
	const queryClient = useQueryClient();

	const query = useReactQueryIsCustomActionEndpointUrlAccessible(
		{id: id || -1},
		{
			enabled: false,
			refetchOnMount: false,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
			retry: false,
		},
	);

	useEffect(() => {
		return () => {
			queryClient.removeQueries({
				queryKey: [isCustomActionEndpointUrlAccessibleEndpoint],
			});
		};
	}, [id]);

	return {
		error: query.isError,
		checking:
			query.fetchStatus !== 'idle' && (query.isLoading || query.isFetching),
		valid: !query.isError ? query.data : false,
		check: query.refetch,
	};
};

export default useIsCustomActionEndpointUrlAccessible;
